import axios from "axios"
export default {

  // 百度转化追踪埋点
  sendData (conversionTypes) {
    let bd_vid = sessionStorage.getItem("bd_vid") || ''
    if (!bd_vid) return
    return new Promise((resolve, reject) => {
      let params = { conversionTypes };
      axios.post(
        "https://api.ceekeeapi.com/tripwise/tripwise-m-api/event-tracking/ocpc/add",
        params,
      ).then((res) => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    });
  }
}